module.exports = __webpack_public_path__ + "img/puzzle2-500.6b881430.png";